((Drupal, once) => {
  Drupal.behaviors.paragraphCards = {
    attach: (context, settings) => {
      // Set the swiper settings for paragraph cards
      if (!settings.neo) {
        settings.neo = {};
      }
      if (!settings.neo.swiperSettings) {
        settings.neo.swiperSettings = {};
      }
      settings.neo.swiperSettings.cards = {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        scrollBar: false,
        speed: 500,
        slidesPerView: 1,
        spaceBetween: Drupal.getVariable('grid-gap', 20),
        breakpoints: {
          500: {
            slidesPerView: 2,
          },
          1000: {
            slidesPerView: 4,
          },
        },
      };
    },
  };
})(Drupal, once);
